import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { FormViewContent } from 'components/FormViewContent';
import molecules from 'ctsutheme/components/molecules';
import atoms from 'ctsutheme/components/atoms';
import {
  GetEmptyValue
// NoChartDataFound
} from 'components';
// import { DoughnutChart } from '@ctsu/charts';
import {
  ListItemSecondaryAction
// Grid
} from '@material-ui/core';
import { compose, withState } from 'recompose';
// import _ from 'lodash';
import PropTypes from 'prop-types';
// import { FasTable, FasChartPie } from 'assets/icons';
import { RenderElement } from 'components/RenderHelpers';
import { GetUserFullName } from 'helpers';
import { TE } from 'appconstants';

const {
  Divider, Typography
  //  Tooltip, IconButton
} = atoms;
const { List, ListSubHeader } = molecules;

const columns = [
  {
    name: 'stepType',
    type: 'string',
    label: 'Accrual Type',
    align: 'left',
    sort: true,
    filterable: false
  },
  {
    name: 'accrualTarget',
    type: 'string',
    label: 'Accrual Target',
    align: 'left',
    sort: true,
    filterable: false
  },
  {
    name: 'accrualTotal',
    type: 'string',
    label: 'Accrual Total',
    align: 'left',
    sort: true,
    filterable: false
  }
];

// const AccrualChart = ({ chartData }) => (!_.isEmpty(chartData) ? (
//   <DoughnutChart
//     data={chartData}
//     chartId="doughnut"
//     variable="accrualTarget"
//     category="stepType"
//   />
// ) : (
//   <NoChartDataFound />
// ));

// AccrualChart.propTypes = {
//   chartData: PropTypes.oneOfType([PropTypes.object])
// };

// AccrualChart.defaultProps = {
//   chartData: null
// };


const Accrual = ({ accrualInfo, state, setState }) => (
  <List
    subheader={(
      <ListSubHeader flex>
        <Typography data-id="accuralInfoTitle" inline primary>
        Accrual Information
        </Typography>
        <ListItemSecondaryAction>
          {/* <Grid
            container
            direction="row"
            justify="flex-end"
            alignItems="center"
            style={{ fontWeight: '400' }}
          >
        View: &nbsp;
            <Tooltip tooltipplacementbottom="true" title="Table Mode">
              <Typography link icon inline>
                <IconButton
                  aria-label="View Grid"
                  data-direction="Right"
                  color={state === 'G' ? 'inherit' : ''}
                  onClick={() => setState('G')}
                >
                  <FasTable />
                </IconButton>
              </Typography>
            </Tooltip>
            {' '}
&nbsp; | &nbsp;
            <Tooltip tooltipplacementbottom="true" title="Chart Mode">
              <Typography link icon inline>
                <IconButton
                  aria-label="View Chart"
                  data-direction="Bottom"
                  color={state === 'C' ? 'inherit' : ''}
                  onClick={() => setState('C')}
                >
                  <FasChartPie />
                </IconButton>
              </Typography>
            </Tooltip>
          </Grid> */}
        </ListItemSecondaryAction>
      </ListSubHeader>
      )}
  >
    <FormViewContent
      primaryText="Projected Start Date"
      name="startDate"
      secondaryText={(
        <GetEmptyValue
          value={accrualInfo && accrualInfo.startDate}
        />
)}
    />
    <Divider />
    <FormViewContent
      primaryText="Projected End Date"
      name="endDate"
      secondaryText={(
        <GetEmptyValue
          value={accrualInfo && accrualInfo.endDate}
        />
)}
    />
    <Divider />
    <RenderElement access={state === 'G'}>
      <div style={{ margin: '1rem 0' }}>
        <GridTable
          tag={`${TE.ID}accrualinfo${TE.TABLE}`}
          columns={columns}
          user={GetUserFullName()}
          rows={(accrualInfo && accrualInfo.accruals) ? accrualInfo.accruals : []}
          filterable
          sortable
          toPdf={false}
        />
      </div>
    </RenderElement>
    {/* <RenderElement access={state === 'C'}>
      <AccrualChart chartData={accrualInfo && accrualInfo.accruals} />
    </RenderElement> */}
  </List>
);


Accrual.propTypes = {
  accrualInfo: PropTypes.oneOfType([PropTypes.object]),
  setState: PropTypes.func
};

Accrual.defaultProps = {
  accrualInfo: null,
  setState: null
};


const AccrualInfo = compose(
  withState('state', 'setState', 'G')
)(Accrual);


export default AccrualInfo;
